import { LoadablePaint } from '@confluence/loadable';

export const LazySystemOperationsPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SystemOperationsPage" */ '../src/SystemOperations/SystemOperationsPage.tsx'
			)
		).SystemOperationsPage,
});
